// extracted by mini-css-extract-plugin
export default {"link":"SidebarNavLink_link__4egRA","linkActive":"SidebarNavLink_linkActive__trkO8"};